import React, { Component } from 'react';
import { connect, useSelector } from 'react-redux';
import TimePicker from '../../../components/TimePicker';
import StepContainer from '../../automation/components/StepContainer';
import ConfirmSetLive from '../../../components/ConfirmSetLive';
import ElementRadio from 'components/ElementRadio';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import GeckoLocation from 'services/gecko-location';
import {
  GECKO_CONSTS,
  GeckoBtn,
  GeckoField,
  GeckoFields,
  GeckoCol,
  GeckoToastService,
} from 'ui';
import AgentSelect from '../../../components/AgentSelect';
import { fetchExports } from './actions';
import { GeckoRow } from '../../../ui';
import './NewExport.scss';
import moment from 'moment';
import TagSelect from '../../../components/TagSelect';
import ChannelSelect from '../../../components/ChannelSelect';
import CONSTANTS from 'chat-constants';

export class NewExport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step1value: undefined,
      _step1value: {
        exportName: undefined,
        exportStatus: 'closed',
        matchRequiredForSync: [],
        tags: [],
        channels: [],
      },
      step2value: undefined,
      _step2value: {
        scheduleDay: undefined,
        scheduleDate: undefined,
        scheduleTime: undefined,
        scheduleType: undefined,
        dateForInitialExport: undefined,
        exportOnlyNewConversations: ['checked'],
      },
      step3value: undefined,
      _step3value: undefined,
      _step4value: {
        enableSftp: false,
        hostname: '',
        port: '',
        username: '',
        password: '',
        filename: '',
        destination: '',
      },
      step4value: undefined,
      dirty: false,
      currentStep: 1,
    };
  }

  componentDidMount = () => {
    // Set default recipient value as current user.
    this.setState({ _step3value: [this.props.currentUserId] });
  };

  nextStep = () => {
    if (this.state.currentStep >= 5) {
      return;
    }
    this.setState({
      currentStep: this.state.currentStep + 1,
    });
  };

  applySftpChange = () => {
    this.setState({ step4value: this.state._step4value, dirty: true });
    this.nextStep();
  };
  applyRecipientChange = () => {
    this.setState({ step3value: this.state._step3value, dirty: true });
    this.nextStep();
  };
  applyNameChange = () => {
    this.setState({ step1value: this.state._step1value, dirty: true });
    this.nextStep();
  };
  applyScheduleChange = () => {
    this.setState({ step2value: this.state._step2value, dirty: true });
    this.nextStep();
  };

  getProgress = (num) => {
    const _key = `_step${num}value`;
    const _value = this.state[_key];
    const key = `step${num}value`;
    const value = this.state[key];
    if (this.state.currentStep === num) {
      return 'in-progress';
    }
    if (_value !== undefined && value === undefined) {
      return 'in-progress';
    }
    if (value !== undefined) {
      return 'complete';
    }
    return 'incomplete';
  };

  isStep = (num) => {
    return this.state.currentStep === num;
  };

  goToStep = (num) => this.setState({ currentStep: num });

  renderSftpFields = () => {
    return [
      {
        key: 'sftp-description',
        type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
        width: '75%',
        render: () => {
          return (
            <p className="description">
              Your export can be delivered to an SFTP server. SFTP allows you to
              pass your data into popular CRMs, such as Banner and Slate.
            </p>
          );
        },
      },
      {
        key: 'enableSftp',
        label: 'Enable SFTP',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      },
      {
        key: 'hostname',
        placeholder: 'ie. examplehost.com',
        label: 'Host Name',
        required: true,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
      {
        key: 'port',
        placeholder: 'ie. 123',
        label: 'Port',
        required: true,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
      {
        key: 'username',
        placeholder: 'ie. sftpuser',
        label: 'Username',
        required: true,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
      {
        key: 'password',
        placeholder: '',
        label: 'Password',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
      {
        key: 'filename',
        placeholder: 'ie. conversation_and_contact_export.csv',
        label: 'File Name',
        required: true,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
      {
        key: 'destination',
        placeholder: 'ie /destination',
        label: 'Destination Path',
        required: true,
        width: '100%',
        hideWhen: () => !this.state._step4value.enableSftp,
      },
    ];
  };
  renderRecipientField = () => {
    return {
      key: '_step3value',
      label: 'Set Recipients',
      required: true,
      description: 'Choose who you would like to receive the export, by email.',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: <AgentSelect />,
    };
  };

  renderExportDetailsFields = () => {
    return [
      {
        label: 'Export Name',
        width: '100%',
        required: true,
        key: 'exportName',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      },
      {
        key: 'exportStatus',
        label: 'Which conversation status would you like to export?',
        width: '100%',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ElementRadio
            options={[
              {
                component: <button>Closed</button>,
                value: 'closed',
              },
              {
                component: <button>Open</button>,
                value: 'open',
              },
              {
                component: <button>Export All</button>,
                value: 'all',
              },
            ]}
          />
        ),
      },
      {
        key: 'tags',
        label: 'Select conversation tags',
        description: 'Leave blank for all tags',
        required: false,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <TagSelect multi={true} />,
      },
      {
        key: 'channels',
        label: 'Select conversation channels',
        description: 'Leave blank for all channels',
        required: false,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ChannelSelect
            includeDeletedChannels={true}
            multi={true}
            allowedChannelTypes={[
              ...CONSTANTS.CHANNEL.PICKABLE_TYPES,
              CONSTANTS.CHANNEL.TYPE_FORM_RESPONSE,
            ]}
          />
        ),
      },
      {
        key: 'matchRequiredForSync',
        width: '100%',
        required: false,
        type: GECKO_CONSTS.FIELD_TYPE_CHECKBOX,
        options: [
          {
            value: 'checked',
            label: (
              <span>
                Only export conversations where the contact has the{' '}
                <a href="/#/settings/customfields">required fields</a>
              </span>
            ),
          },
        ],
      },
    ];
  };

  renderExportScheduleFields = () => {
    return [
      {
        key: 'scheduleType',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        placeholder: 'Select Frequency',
        label: 'Export Frequency',
        description: 'Choose how often you want the export to run',
        options: [
          {
            label: 'Daily',
            value: 'Daily',
          },
          {
            label: 'Weekly',
            value: 'Weekly',
          },
          {
            label: 'Monthly',
            value: 'Monthly',
          },
        ],
      },
      {
        key: 'scheduleTime',
        required: true,
        label: 'Time of Export',
        description: 'Choose what time you want the export to run',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <TimePicker />,
      },
      {
        key: 'scheduleDate',
        label: 'Day of Monthly Export',
        required: this.state._step2value.scheduleType === 'Monthly',
        hideWhen: () => this.state._step2value.scheduleType !== 'Monthly',
        description: 'Choose which day of the month you want the export to run',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: [
          {
            label: '1st',
            value: '1',
          },
          {
            label: '2nd',
            value: '2',
          },
          {
            label: '3rd',
            value: '3',
          },
          {
            label: '4th',
            value: '4',
          },
          {
            label: '5th',
            value: '5',
          },
          {
            label: '6th',
            value: '6',
          },
          {
            label: '7th',
            value: '7',
          },
          {
            label: '8th',
            value: '8',
          },
          {
            label: '9th',
            value: '9',
          },
          {
            label: '10th',
            value: '10',
          },
          {
            label: '11th',
            value: '11',
          },
          {
            label: '12th',
            value: '12',
          },
          {
            label: '13th',
            value: '13',
          },
          {
            label: '14th',
            value: '14',
          },
          {
            label: '15th',
            value: '15',
          },
          {
            label: '16th',
            value: '16',
          },
          {
            label: '17th',
            value: '17',
          },
          {
            label: '18th',
            value: '18',
          },
          {
            label: '19th',
            value: '19',
          },
          {
            label: '20th',
            value: '20',
          },
          {
            label: '21st',
            value: '21',
          },
          {
            label: '22nd',
            value: '22',
          },
          {
            label: '23rd',
            value: '23',
          },
          {
            label: '24th',
            value: '24',
          },
          {
            label: '25th',
            value: '25',
          },
          {
            label: '26th',
            value: '26',
          },
          {
            label: '27th',
            value: '27',
          },
          {
            label: '28th',
            value: '28',
          },
        ],
      },
      {
        key: 'scheduleDay',
        required: this.state._step2value.scheduleType === 'Weekly',
        hideWhen: () => this.state._step2value.scheduleType !== 'Weekly',
        description: 'Choose which day of the week you want the export to run',
        options: [
          {
            label: 'Sunday',
            value: 7,
          },
          {
            label: 'Monday',
            value: 1,
          },
          {
            label: 'Tuesday',
            value: 2,
          },
          {
            label: 'Wednesday',
            value: 3,
          },
          {
            label: 'Thursday',
            value: 4,
          },
          {
            label: 'Friday',
            value: 5,
          },
          {
            label: 'Saturday',
            value: 6,
          },
        ],
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        placeholder: 'Select Frequency Day',
        label: 'Export Day',
      },
      {
        key: 'dateForInitialExport',
        type: GECKO_CONSTS.FIELD_TYPE_DATE,
        width: '50%',
        placeholder: 'All Data',
        label: 'Only Include Data From',
        description:
          'This will ensure that only data collected after this date is included in your export',
      },
      {
        key: 'exportOnlyNewConversations',
        type: GECKO_CONSTS.FIELD_TYPE_CHECKBOX,
        width: '100%',
        options: [
          {
            value: 'checked',
            label:
              'Only export conversations that have been created / updated since last export',
          },
        ],
      },
    ];
  };

  onChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onChangeExportDetails = (key, value) => {
    this.setState({ _step1value: { ...this.state._step1value, [key]: value } });
  };

  onChangeSchedule = (key, value) => {
    const _step2value = Object.assign({}, this.state._step2value, {
      [key]: value,
    });
    this.setState({ _step2value });
  };

  isScheduleValid = () => {
    if (this.state.step2value === undefined) {
      return false;
    }
    const { scheduleType, scheduleDate, scheduleDay, scheduleTime } =
      this.state.step2value;
    // monthly check
    if (scheduleType === 'Monthly') {
      return !(scheduleDate == null || scheduleTime == null);
    }

    if (scheduleType === 'Daily') {
      return scheduleTime !== undefined;
    }

    if (scheduleType === 'Weekly') {
      return !(scheduleDay === undefined || scheduleTime == null);
    }

    return false;
  };

  onSftpChange = (key, value) => {
    const _step4value = Object.assign({}, this.state._step4value, {
      [key]: value,
    });
    this.setState({ _step4value });
  };

  isSftpValid = () => {
    if (this.state.step4value === undefined) {
      return false;
    }
    if (!this.state.step4value.enableSftp) {
      return true;
    } else {
      return this.isSftpDetailsCompleted();
    }
  };

  testIntegration = () => {
    const { filename, hostname, port, username, password, destination } =
      this.state._step4value;
    GeckoRequest.post(`/exports/test-sftp`, {
      config: {
        hostname,
        port: Number(port),
        username,
        password,
        filename,
        pathname: destination,
      },
    })
      .then(() => {
        new GeckoToastService().success('SFTP test was successful!');
      })
      .catch(renderError);
  };

  isSftpDetailsCompleted = () => {
    const { filename, hostname, port, username, password, destination } =
      this.state._step4value;
    if (!filename || !filename.length) {
      return false;
    }
    if (!hostname || !hostname.length) {
      return false;
    }
    if (!port) {
      return false;
    }
    if (!username || !username.length) {
      return false;
    }
    if (!password || !password.length) {
      return false;
    }
    if (!destination || !destination.length) {
      return false;
    }

    return true;
  };

  getExportFilters = () => {
    const { tags, channels } = this.state.step1value;
    return {
      tags,
      channels,
    };
  };

  createExport = (executeNow = false) => {
    const { exportName, exportStatus, matchRequiredForSync } =
      this.state.step1value;
    const {
      scheduleTime,
      scheduleType,
      scheduleDay,
      scheduleDate,
      dateForInitialExport,
      exportOnlyNewConversations,
    } = this.state.step2value;
    const agentIds = this.state.step3value;

    const filters = this.getExportFilters();

    const {
      filename,
      hostname,
      port,
      username,
      password,
      destination,
      enableSftp,
    } = this.state.step4value;

    const sftpDetails = enableSftp
      ? {
          filename,
          hostname,
          port: Number(port),
          username,
          password,
          pathname: destination,
        }
      : {};

    let params = {
      exportName,
      exportStatus,
      matchRequiredForSync: !!matchRequiredForSync.length,
      scheduleDay,
      scheduleTime,
      scheduleDate,
      scheduleType,
      agentIds,
      ...filters,
      executeNow: true,
      sftp: enableSftp,
      dateForInitialExport: moment(new Date(dateForInitialExport)).unix(),
      exportOnlyNewConversations: !!exportOnlyNewConversations.length,
    };
    params = Object.assign({}, params, sftpDetails);
    return GeckoRequest.post('/exports', params).then(() =>
      fetchExports()
        .then(() => {
          new GeckoToastService().success(
            'Your recurring export has been setup successfully.'
          );
        })
        .finally((_) =>
          GeckoLocation.goTo('/settings/exports').catch(renderError)
        )
    );
  };

  render() {
    return (
      <div className="NewExport content-margin">
        <StepContainer
          stepNumber={1}
          name="Export Details"
          stepState={this.getProgress(1)}
          expanded={this.isStep(1)}
          onNext={this.applyNameChange}
          onClick={() => this.goToStep(1)}
        >
          <GeckoRow>
            <GeckoFields
              values={this.state._step1value}
              handler={this.onChangeExportDetails}
              fields={this.renderExportDetailsFields()}
            />
          </GeckoRow>
        </StepContainer>
        <StepContainer
          stepNumber={2}
          name="Export Schedule"
          stepState={this.getProgress(2)}
          expanded={this.isStep(2)}
          onNext={this.applyScheduleChange}
          onClick={() => this.goToStep(2)}
        >
          <GeckoRow>
            <GeckoFields
              handler={this.onChangeSchedule}
              values={this.state._step2value}
              fields={this.renderExportScheduleFields()}
            />
          </GeckoRow>
        </StepContainer>
        <StepContainer
          stepNumber={3}
          name="Set Recipients"
          stepState={this.getProgress(3)}
          expanded={this.isStep(3)}
          onNext={this.applyRecipientChange}
          onClick={() => this.goToStep(3)}
        >
          <GeckoField
            field={this.renderRecipientField()}
            handler={this.onChange}
            values={this.state}
          />
        </StepContainer>
        <StepContainer
          stepNumber={4}
          name="Setup SFTP"
          stepState={this.getProgress(4)}
          expanded={this.isStep(4)}
          onNext={this.applySftpChange}
          onClick={() => this.goToStep(4)}
        >
          <GeckoRow>
            <GeckoFields
              fields={this.renderSftpFields()}
              handler={this.onSftpChange}
              values={this.state._step4value}
            />
          </GeckoRow>
          <GeckoRow>
            <GeckoCol width="12">
              {this.state._step4value.enableSftp ? (
                <GeckoBtn
                  disabledWhen={() => !this.isSftpDetailsCompleted()}
                  name="Test Integration"
                  type={GECKO_CONSTS.BTN_TYPE_DEFAULT}
                  handler={this.testIntegration}
                />
              ) : null}
            </GeckoCol>
          </GeckoRow>
        </StepContainer>
        <StepContainer
          stepNumber={5}
          name="Review and Confirm"
          expanded={this.isStep(5)}
          nextDisabled={
            this.state.step1value === undefined ||
            !this.isScheduleValid() ||
            this.state.step3value === undefined || // Must have at least 1 recipient.
            !this.state.step3value.length ||
            !this.isSftpValid()
          }
          onSetLive={this.createExport}
          onClick={() => this.goToStep(5)}
        >
          <ConfirmSetLive
            steps={[
              {
                warning: "You haven't provided a name for the export",
                isValid: this.state.step1value?.exportName !== undefined,
              },
              {
                warning: "You haven't provided a valid schedule for the export",
                isValid: this.isScheduleValid(),
              },
              {
                warning: 'You must provide at least 1 recipient for the export',
                isValid:
                  this.state.step3value !== undefined &&
                  this.state.step3value.length,
              },
              {
                warning:
                  "You haven't specified enough SFTP details for the export - either disable SFTP or complete the required details.",
                isValid: this.isSftpValid(),
              },
            ]}
            readyMessage="It looks like your export is ready to go. Good Job!"
            notReadyMessage="It looks like your export has some issues"
            changeStep={(num) => this.setState({ currentStep: num })}
          />
        </StepContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    agents: state.visible_agents,
    currentUserId: state.appState.loggedInUser.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewExport);
